import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { SoortTemperatuur } from '../dto/soort-temp';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class SoortTempService extends CrudService<SoortTemperatuur> {

    constructor(injector: Injector) { super(SoortTemperatuur, injector); }

}
